<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12.5 2.5C15.1522 2.5 17.6957 3.55357 19.5711 5.42893C21.4464 7.3043 22.5 9.84784 22.5 12.5C22.5 18.0228 18.0228 22.5 12.5 22.5C6.97715 22.5 2.5 18.0228 2.5 12.5C2.5 6.97715 6.97715 2.5 12.5 2.5ZM12.5005 4.1668C7.89815 4.1668 4.16719 7.89776 4.16719 12.5001C4.16719 17.1025 7.89815 20.8335 12.5005 20.8335C17.1029 20.8335 20.8339 17.1025 20.8339 12.5001C20.8339 7.89776 17.1029 4.1668 12.5005 4.1668ZM19.4 12.5C19.4 8.68924 16.3108 5.6 12.5 5.6C8.68924 5.6 5.6 8.68924 5.6 12.5C5.6 16.3108 8.68924 19.4 12.5 19.4C16.3108 19.4 19.4 16.3108 19.4 12.5ZM17.3662 12.4994C17.366 9.81184 15.1867 7.6332 12.499 7.6332C9.8116 7.63345 7.63306 9.81199 7.63281 12.4994C7.63281 15.187 9.81145 17.3664 12.499 17.3666C15.1868 17.3666 17.3662 15.1872 17.3662 12.4994ZM18.3662 12.4994C18.3662 15.7395 15.7391 18.3666 12.499 18.3666C9.25916 18.3664 6.63281 15.7393 6.63281 12.4994C6.63306 9.25971 9.25931 6.63345 12.499 6.6332C15.7389 6.6332 18.366 9.25955 18.3662 12.4994ZM16.3339 12.5001C16.3339 10.383 14.6176 8.6668 12.5005 8.6668C10.3834 8.6668 8.66719 10.383 8.66719 12.5001C8.66719 14.6172 10.3834 16.3335 12.5005 16.3335C14.6176 16.3335 16.3339 14.6172 16.3339 12.5001Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgTarget',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
